import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { getBranches } from "../api/contest";
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';

const useBranches = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const result = useQuery(["branches", id], async () => {
    if (id) {
      const res = await getBranches({ id });
      return res.data;
    } else {
      Sentry.captureMessage("Please enter valid url. [lack-token]");
      toast.warn("Please enter valid url.");
    }
    return null;
  }, {
    onError: (err: any) => {
      Sentry.captureException(err);
      toast.warn(err.message);
    }
  });

  return result;
}

export default useBranches;